/* global dataLayer */
 
import { cookie } from 'reduxModules/utils/cookie'

import { logout } from 'reduxModules/auth'
import authTypes from 'reduxModules/auth/types'
import { releaseHijackedUser } from 'reduxModules/hijack'
import { toggleMobileMenu } from 'reduxModules/app'
import { closeItemModal } from 'reduxModules/cart'
import { homeFetch } from 'reduxModules/home'
import { navigate } from '../../../utils/navigation'
import { hideCookieNotice, showCookieNotice, toggleSearchBox } from './'
import { clearSuggestions, searchSuggestFetch } from '../newSearch'
import notifications, {
  toastError,
  toastServerError,
  toastSuccess
} from '../../../global/notifications'

const THREE_MONTHS_IN_MS = 7890000000
// Renamed from `showCookieNotice` (which was historically written without an
// explicit path, leaving stale path-scoped duplicates that masked the user's
// accept choice on other routes). Treat presence of this cookie as "accepted".
const COOKIE_NOTICE_KEY = 'cookieNoticeAccepted'

export const logoutFlow = (dispatch, props) =>
  dispatch(logout())
    .then(([_, res]) => {
      if (res.type === authTypes.AUTH_LOGOUT_SUCCESS) {
        toastSuccess(notifications.logout)
        dataLayer.push({ isLoggedIn: false })
        if (props?.pathName === '/') dispatch(homeFetch())
        else navigate('/')
      } else toastError(notifications.logout)
    })
    .catch((payload) => {
      const error = payload.errors
      toastServerError(error)
    })

export const dispatchToggleSearchBox = (dispatch) => dispatch(toggleSearchBox())

export const releaseHijacked = (dispatch) => {
  dispatch(releaseHijackedUser())
  navigate('/account')
  toastSuccess(notifications.userReleased)
}

export default (dispatch, props) => ({
  getInitialShowCookieNoticeState: () => {
    dispatch(cookie(COOKIE_NOTICE_KEY)).then((cookieValue) => {
      if (cookieValue === undefined) dispatch(showCookieNotice())
    })
  },
  hideCookieNotice: () => {
    dispatch(hideCookieNotice())
    dispatch(
      cookie(COOKIE_NOTICE_KEY, '1', {
        maxage: THREE_MONTHS_IN_MS,
        path: '/'
      })
    )
  },
  toggleSearchBox: () => {
    dispatch(clearSuggestions())
    dispatchToggleSearchBox(dispatch)
  },
  logout: () => logoutFlow(dispatch, props),
  toggleMobileMenu() {
    dispatch(toggleMobileMenu())
  },
  releaseHijacked: () => releaseHijacked(dispatch),
  closeItemModal: () => dispatch(closeItemModal()),
  getSearchSuggestions(query) {
    dispatch(searchSuggestFetch(query)())
  },
  clearSuggestions() {
    dispatch(clearSuggestions())
  }
})
